export const base = 'getFiles';

export const getImportRfv = `${base}/import-rfv`;
export const getPresignedUrlRfv = `${base}/download-rfv-csv`;
